import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, createElementVNode as _createElementVNode, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "agila-dropdown-filter" }
const _hoisted_2 = ["id", "for"]
const _hoisted_3 = {
  key: 0,
  class: "agila-dropdown-filter-headline"
}

import { ref } from "vue";
import Select from "primevue/select";
import AgilaFormError from "./agilaFormError.vue";
import useSharedFormLogic from "../helper/functions/useSharedFormLogic";

interface Props {
  emptyFilterMessage?: string;
  dataKey?: string;
  optionLabel?: string;
  id: string;
  modelValue?: any;
  placeholder?: string;
  scrollHeight?: string;
  label?: string;
  showLabel?: boolean;
  showError?: boolean;
  options: Array<any>;
  rules?: string[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'agilaDropdownFilter',
  props: {
    emptyFilterMessage: { default: "Keine Ergebnisse gefunden" },
    dataKey: { default: "id" },
    optionLabel: { default: "name" },
    id: { default: "" },
    modelValue: { default: null },
    placeholder: { default: "Bitte wählen" },
    scrollHeight: { default: "394px" },
    label: { default: "" },
    showLabel: { type: Boolean, default: false },
    showError: { type: Boolean, default: false },
    options: { default: () => [] },
    rules: { default: () => [] }
  },
  emits: ["update:modelValue", "update:error", "selectItem"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const dropdown = ref(null);
const filterValue = ref();
const placeholder = ref(props.placeholder);

const emit = __emit;

function filterDropdown(event: any) {
  filterValue.value = event.value;
  if (inputValue.value) {
    placeholder.value = inputValue.value[props.optionLabel];
  }
}

const { readyForCheck, inputValue, error, updateValue, validate } =
  useSharedFormLogic(props, emit);

__expose({
  validate: () => {
    readyForCheck.value = true;
    return validate(inputValue.value);
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (props.label && props.showLabel)
        ? (_openBlock(), _createElementBlock("label", {
            key: 0,
            id: props.id + '-label',
            for: props.id
          }, _toDisplayString(props.label), 9, _hoisted_2))
        : _createCommentVNode("", true),
      (props.showError)
        ? (_openBlock(), _createBlock(AgilaFormError, {
            key: 1,
            error: _unref(error),
            id: props.id + '-error'
          }, null, 8, ["error", "id"]))
        : _createCommentVNode("", true),
      _createVNode(_unref(Select), {
        modelValue: _unref(inputValue),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(inputValue) ? (inputValue).value = $event : null)),
        ref_key: "dropdown",
        ref: dropdown,
        filter: "",
        autoFilterFocus: "",
        tabindex: 0,
        dataKey: props.dataKey,
        inputId: props.dataKey,
        optionLabel: props.optionLabel,
        placeholder: placeholder.value,
        emptyFilterMessage: props.emptyFilterMessage,
        options: _ctx.options,
        resetFilterOnHide: true,
        onChange: _cache[2] || (_cache[2] = ($event: any) => {
          readyForCheck.value = true;
          _unref(updateValue)();
        }),
        onInput: _cache[3] || (_cache[3] = ($event: any) => (_unref(updateValue)())),
        onFilter: _cache[4] || (_cache[4] = ($event: any) => (filterDropdown($event))),
        scrollHeight: props.scrollHeight,
        "aria-label": props.label + ':' + placeholder.value,
        invalid: !!_unref(error),
        pt: {
          header: { class: 'agila-dropdown-filter-header' },
          overlay: {
            class: 'agila-dropdown-filter-panel',
          },
        },
        "aria-describedby": props.id + '-error'
      }, {
        header: _withCtx(() => [
          (props.label)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(props.label), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "agila-icon-skip-container",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (dropdown.value.hide()))
          }, _cache[5] || (_cache[5] = [
            _createElementVNode("div", { class: "agila-icon-skip" }, null, -1)
          ]))
        ]),
        _: 1
      }, 8, ["modelValue", "dataKey", "inputId", "optionLabel", "placeholder", "emptyFilterMessage", "options", "scrollHeight", "aria-label", "invalid", "aria-describedby"])
    ])
  ]))
}
}

})